module.exports = __webpack_public_path__ + "media/images/Church-Abstract-ab1ade0ce3769dc895bf6bf93b38230c.jpg";